import * as types from "./types";
import { createReducer } from "../../utils";

/* State shape
{
    session: object
}
*/

const initialState = {
  isAuthenticated: false,
  redirectAfterLogin: null,
  token: window.localStorage.getItem("token"),
  refreshToken: window.localStorage.getItem("refresh_token"),
  isLoading: false,
  establishment: null,
};

const sessionReducer = createReducer(initialState)({
  [types.GET_ESTABLISHMENT]: (state, action) => {
    window.localStorage.setItem("token", action.payload.token);
    window.localStorage.setItem("refresh_token", action.payload.refreshToken);
    return {
      ...state,
      establishment: action.payload.id,
      token: action.payload.token,
      refreshToken: action.payload.refreshToken,
    };
  },
  /**
   * Le token a été renouvelé par le middleware API (401 -> /token/refresh).
   * Sans ce cas, `session.token` gardait le token du chargement de la page :
   * fetch() lui donne la priorité sur le localStorage, donc chaque requête
   * repartait avec un token périmé -> 401 -> refresh -> rejeu, en boucle.
   */
  [types.TOKEN_REFRESHED]: (state, action) => {
    return {
      ...state,
      token: action.payload.token,
      refreshToken: action.payload.refreshToken,
    };
  },

  [types.LOGIN]: (state, action) => {
    return { ...state, isLoading: true };
  },
  [types.LOGIN_FAILED]: (state, action) => {
    return { ...state, isLoading: false };
  },

  [types.LOGIN_COMPLETED]: (state, action) => {
    return {
      ...state,
      redirectAfterLogin: action.payload.redirectUrl,
      isAuthenticated: true,
      isLoading: false,
      token: action.payload.result,
    };
  },

  [types.LOGOUT]: (state, action) => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("refresh_token");
    return initialState;
  },
});

export default sessionReducer;
